export const getBlockElementSelector = blockId => `[data-block-id="${blockId}"]`

export const getCenteredScrollTop = (container, element) => {
  const containerRect = container.getBoundingClientRect()
  const elementRect = element.getBoundingClientRect()
  const elementTop = elementRect.top - containerRect.top + container.scrollTop
  const centeredTop = elementTop - (container.clientHeight - elementRect.height) / 2

  return Math.max(0, centeredTop)
}
